import {readCart,saveCart} from "./hooks/cartPersistence";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userConfigSlice from "./reducers/userConfigSlice";

const rootReducer = combineReducers({
  aplicationConfig: userConfigSlice,
});

const base = rootReducer(undefined,{type:"init"});
const guest = typeof window !== "undefined" ? readCart() : null;
export const store = configureStore({
  preloadedState: guest ? {...base,aplicationConfig:{...base.aplicationConfig,userConfig:{...base.aplicationConfig.userConfig,cart:guest}}} : undefined,
  reducer: rootReducer,
});

let lastCart=store.getState().aplicationConfig.userConfig.cart;
store.subscribe(()=>{
 const user=store.getState().aplicationConfig.userConfig;
 if(user.cart!==lastCart) {
  lastCart=user.cart;
  if(typeof window!=="undefined") {saveCart(user.cart,user.logged?user.userData?.customerId:null);}
 }
});
